import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

const PAGESIZE = 20 // 这里后端没按limit返回，固定一页20条
export const getAgencyRechargeDetail = createAsyncThunk(
  'CoinAgencyWallet/getAgencyRechargeDetail',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/get_ra_recharge_detail', {
      ...store.getState().env.deviceinfo,
      limit: PAGESIZE,
      ...params,
    })
    return {data: resp.data.data, offset: params.offset}
  }
)

// 高级币商查看分销商 分销以及卖币 详情 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96305373
// kind 1自己卖币给分销商（币商金币）记录  2 自己的分销商卖币记录 3 (分销商自己的买币记录）
export const seniorTradeHis = createAsyncThunk(
  'senior_trade_his',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/senior_trade_his', {
      ...store.getState().env.deviceinfo,
      page_size: PAGESIZE,
      ...params,
      kind: 3,
    })
    return resp.data
  }
)

export const getAgencyTradeDetail = createAsyncThunk(
  'CoinAgencyWallet/getAgencyTradeDetail',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/get_ra_trade_detail', {
      ...store.getState().env.deviceinfo,
      limit: PAGESIZE,
      ...params,
    })
    return {data: resp.data.data, offset: params.offset}
  }
)

export const getAgencyObtainDetail = createAsyncThunk(
  'CoinAgencyWallet/getAgencyObtainDetail',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/get_ra_obtain_detail', {
      ...store.getState().env.deviceinfo,
      limit: PAGESIZE,
      ...params,
    })
    return {data: resp.data.data, offset: params.offset}
  }
)

export const getCoinagencyInfo = createAsyncThunk(
  'CoinAgencyWallet/getCoinagencyInfo',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/get_ra_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const getCoinAgencyRankIsOn = createAsyncThunk(
  'CoinAgencyWallet/getCoinAgencyRankIsOn',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/is_recharge_agency_rank_on', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

// 币商banner http://wiki.xunlei.cn/pages/viewpage.action?pageId=92444874
export const get_banners = createAsyncThunk(
  'CoinAgencyWallet_get_banners',
  async (params, store: any) => {
    const resp = await http.post('/live/misc/get_banners', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// 查询是否被超级币商分销过金币 http://wiki.xunlei.cn/pages/viewpage.action?pageId=117021249
export const checkAssigned = createAsyncThunk(
  'CoinAgencyWallet_/live/pay/super_ra_trade_his',
  async (params, store: any) => {
    const resp = await http.post<
      HiyaRes<{list: any[]; current_amount: number}>
    >('/live/pay/super_ra_trade_his', {
      ...store.getState().env.deviceinfo,
      kind: 2,
      offset: 0,
      limit: 1,
    })
    return resp.data.data
  }
)
const initState = {
  rechargeDetail: {
    more: false,
    list: [],
    offset: 0,
    page: undefined,
  },
  distributorBuyDetail: {
    offset: undefined,
    list: [],
    kind: 3,
    page: 1,
    page_size: 20,
    more: false,
    total: 0,
  },
  tradeDetail: {
    more: false,
    list: [],
    offset: 0,
    page: undefined,
  },
  obtainDetail: {
    more: false,
    list: [],
    offset: 0,
    page: undefined,
  },
  current_amount: 0,
  is_activity_on: false,
  trade_allowed: false, // 准币商不展示sale coins按钮
  count_down: 0,
  senior_mid: 0, // 上家高级币商的mid
  senior_show_id: 0, // 工会id
  // 是否参加币商充值活动
  in_activity: true,
  banner_img: '',
  activity_url: '',
  banner_list: [],
  status: 0, //  0普通用户  1上家异常的分销商  2上家正常的分销商  3考核期币商  4普通币商  5高级币商
  pre_status: 0, // 七日内最高
  is_super: false, // true:是超级币商
  is_assigned: false, // true:有被分销的记录
}

export const AgencyWallet = createSlice({
  name: 'CoinAgencyWallet',
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAgencyRechargeDetail.fulfilled, (state, action) => {
      const {data, offset} = action.payload
      if (!offset) {
        Object.assign(state, {rechargeDetail: data})
        return
      }
      Object.assign(state, {
        rechargeDetail: {
          ...data,
          list: [...state.rechargeDetail.list, ...data.list],
        },
      })
    })
    builder.addCase(seniorTradeHis.fulfilled, (state, action) => {
      const {data} = action.payload
      if (data.page === 1) {
        Object.assign(state, {distributorBuyDetail: data})
        return
      }
      Object.assign(state, {
        distributorBuyDetail: {
          ...data,
          list: [...state.distributorBuyDetail.list, ...data.list],
        },
      })
    })
    builder.addCase(getAgencyTradeDetail.fulfilled, (state, action) => {
      const {data, offset} = action.payload
      if (!offset) {
        Object.assign(state, {tradeDetail: data})
        return
      }
      Object.assign(state, {
        tradeDetail: {
          ...data,
          list: [...state.tradeDetail.list, ...data.list],
        },
      })
    })
    builder.addCase(getAgencyObtainDetail.fulfilled, (state, action) => {
      const {data, offset} = action.payload
      if (!offset) {
        Object.assign(state, {obtainDetail: data})
        return
      }
      Object.assign(state, {
        obtainDetail: {
          ...data,
          list: [...state.obtainDetail.list, ...data.list],
        },
      })
    })
    builder.addCase(getCoinagencyInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getCoinAgencyRankIsOn.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(get_banners.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(checkAssigned.fulfilled, (state, action) => {
      Object.assign(state, {
        // 如果有分销记录就是被分销过
        is_assigned: action.payload?.list?.length > 0,
      })
    })
  },
})

export default AgencyWallet.reducer
